/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_No_AccountInputs */

const en_auth_login_no_account = /** @type {(inputs: Auth_Login_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account yet?`)
};

/**
* | output |
* | --- |
* | "No account yet?" |
*
* @param {Auth_Login_No_AccountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_no_account = /** @type {((inputs?: Auth_Login_No_AccountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_No_AccountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_no_account(inputs)
});